import { toRem } from "../../../../helpers/theme";

const style = ({ theme, checked }) => {
    const config = {
        border: {
            width: 2,
            radius: 5,
            offset: 8,
        },
        check: {
            dimension: 25,
            fontSize: 21,
            radius: 100,
            position: {
                top: 7,
                right: 7,
            },
        },
        transition: {
            transitionDuration: theme.transitions.default.duration,
            transitionTimingFunction: theme.transitions.default.timingFunction,
            transitionDelay: theme.transitions.default.delay,
            transitionProperty: "opacity",
        },
    };
    return {
        position: "relative",
        cursor: "pointer",
        "&::after": {
            content: '""',
            display: "block",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: `calc(100% + ${toRem(config?.border?.offset)})`,
            height: `calc(100% + ${toRem(config?.border?.offset)})`,
            border: `${toRem(config?.border?.width)} solid`,
            borderColor: theme.colors.imageUploader.gallery.image.active.border,
            borderRadius: toRem(config?.border?.radius),
            opacity: checked ? 1 : 0,
            ...config.transition,
            pointerEvents: "none",
        },
        input: {
            position: "absolute",
            zIndex: theme.zIndex.over,
            top: 0,
            left: 0,
            display: "block",
            margin: 0,
            padding: 0,
            width: "100%",
            height: "100%",
            cursor: "inherit",
            opacity: 0,
        },
        "& .uploaderGalleryImage_icon": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: toRem(config?.check?.dimension),
            height: toRem(config?.check?.dimension),
            position: "absolute",
            top: toRem(config?.check?.position?.top),
            right: toRem(config?.check?.position?.right),
            borderRadius: toRem(config?.check?.radius),
            fontSize: toRem(config?.check?.fontSize),
            color: theme.colors.imageUploader.gallery.image.active.text,
            background: theme.colors.imageUploader.gallery.image.active.icon,
            overflow: "hidden",
            opacity: checked ? 1 : 0,
            ...config.transition,
            pointerEvents: "none",
            svg: {
                path: {
                    fill: "currentColor",
                },
            },
        },
    };
};

export default style;
